<ngx-spinner bdColor="rgba(51,51,51,0.55)"
             size="medium"
             color="#fff"
             type="line-spin-clockwise-fade"
             [fullScreen]="false">
    <p class="loading">{{'general.loading' | translate}}...</p>
</ngx-spinner>
<div class="col-12" id="account">
    <h2 class="page-title">{{'account.payment-methods' | translate}}</h2>
    <div class="pb-1">
        <xng-breadcrumb separator=" > ">
            <ng-container *xngBreadcrumbItem="let breadcrumb">
                <span *ngIf="breadcrumb">{{ 'account.' + breadcrumb | translate }}</span>
            </ng-container>
        </xng-breadcrumb>
    </div>
    <div *ngIf="cardList!=null">
        <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-3 mb-2" *ngFor="let card of cardList">
                <div class="card border-secondary">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-2 text-right h4"><i [class]="functionsService.getCardLogo(card.brand)"></i></div>
                            <div class="col-8 text-right">
                                <div *ngIf="card.preferred==true">
                                    <span class="preferred-card">{{'account.preferred' | translate}}</span>
                                </div>
                            </div>
                            <div class="col-2">
                                <div class="dropdown" ngbDropdown placement="bottom" >
                                    <span ngbDropdownToggle tabindex="0" role="button" class="btn btn-default pt-0 pb-0 dark-gray-text cursor"><i class="fa fa-ellipsis-v"></i></span>
                                    <div ngbDropdownMenu class="dropdown-menu dropdown-menu-left">
                                        <button ngbDropdownItem [routerLink]="['edit-card', card.id]" routerLinkActive="active" title="{{'general.edit' | translate}}"><i class="fa fa-pencil"></i> {{'general.edit' | translate}}</button>
                                        <button *ngIf="!card.preferred" ngbDropdownItem (click)="setAsPreferred(card)" title="{{'account.set_preferred' | translate}}"><i class="fa fa-star"></i> {{'account.set_preferred' | translate}}</button>
                                        <button *ngIf="(cardList.length > 1)&&(!card.preferred)" ngbDropdownItem (click)="deleteCard(card)" title="{{'general.remove' | translate}}"><i class="fa fa-trash"></i> {{'general.remove' | translate}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 dark-gray-text">**** **** **** {{card.last4}}</div>
                        </div>
                        <div class="row dark-gray-text">
                            <div class="col-8 text-left">{{card.name}}</div>
                            <div class="col-4 text-right text-nowrap">{{card.exp_month}}/{{card.exp_year}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="cardList==null">
        <div class="row">
            <div class="col-12 p-2">
                <div class="col-3">
                    <div class="card border-secondary">
                        <div class="card-body">
                            -
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-12">
            <div class="card border-top">
                <div class="card-body">
                    <h4 class="page-title mt-0">{{'account.add_card' | translate}}</h4>
                    <hr>
                    <strong>{{'account.card_information' | translate}}:</strong>
                    <form [formGroup]="addCardForm" class="w-100 mt-2" name="form" (ngSubmit)="addCard()">
                        <div class="row">
                            <div class="col-sm-12 col-md-6">
                                <label for="CardName">{{'account.card_name' | translate}}<span class="error">*</span></label>
                                <input id="CardName" type="text" formControlName="CardName" class="form-control" maxlength="26" 
                                [ngClass]="{ 'is-valid': CardName['valid'], 'is-invalid': CardName['invalid'] }"  />
                                <ng-container *ngIf="addCardForm.get('CardName').invalid && (formSubmitted || addCardForm.get('CardName').touched || addCardForm.get('CardName').dirty)">
                                    <div *ngIf="addCardForm.get('CardName').hasError('required')" class="error">
                                        {{'general.required_field' | translate}}
                                    </div>
                                    <div *ngIf="addCardForm.get('CardName').hasError('pattern')" class="error">
                                        {{'error.card_name' | translate}}
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 mb-1">
                                <div class="top-bottom">{{'account.card_number' | translate}}<span class="error">*</span></div>
                                <ngx-stripe-card #card [options]="cardOptions" [elementsOptions]="elementsOptions" (change)="cardUpdated($event)" (error)="error = $event"></ngx-stripe-card>
                                <div class="error">
                                {{error?.message}}
                                </div>
                            </div>
                        </div>
                        <hr>
                        <strong>{{'account.billing_address' | translate}}: </strong>
                        <div class="row mt-2">
                            <div class="col-12">
                                <label for="BillingAddress">{{'user.address' | translate}}<span class="error">*</span></label>
                                <input id="BillingAddress" type="text" formControlName="BillingAddress" class="form-control" maxlength="100"
                                [ngClass]="{ 'is-valid': BillingAddress['valid'], 'is-invalid': BillingAddress['invalid'] }"  />
                                <ng-container *ngIf="addCardForm.get('BillingAddress').invalid && (formSubmitted || addCardForm.get('BillingAddress').touched || addCardForm.get('BillingAddress').dirty)">
                                    <div *ngIf="addCardForm.get('BillingAddress').hasError('required')" class="error">
                                        {{'general.required_field' | translate}}
                                    </div>
                                    <div *ngIf="addCardForm.get('BillingAddress').hasError('pattern')" class="error">
                                        {{'error.address' | translate}}
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-4">
                                <label for="BillingCity" class="top-bottom">{{'user.city' | translate}}<span class="error">*</span></label>
                                <input id="BillingCity" type="text" formControlName="BillingCity" class="form-control" maxlength="50"
                                [ngClass]="{ 'is-valid': BillingCity['valid'], 'is-invalid': BillingCity['invalid'] }"  />
                                <ng-container *ngIf="addCardForm.get('BillingCity').invalid && (formSubmitted || addCardForm.get('BillingCity').touched || addCardForm.get('BillingCity').dirty)">
                                    <div *ngIf="addCardForm.get('BillingCity').hasError('required')" class="error">
                                        {{'general.required_field' | translate}}
                                    </div>
                                    <div *ngIf="addCardForm.get('BillingCity').hasError('pattern')" class="error">
                                        {{'error.address' | translate}}
                                    </div>
                                </ng-container>
                            </div>
                            <div class="col-sm-12 col-md-4">
                                <label for="BillingState" class="top-bottom">{{'user.state' | translate}}<span class="error">*</span></label>
                                <input type="text" id="BillingState" formControlName="BillingState" class="form-control" maxlength="50"
                                [ngClass]="{ 'is-valid': BillingState['valid'], 'is-invalid': BillingState['invalid'] }"  />
                                <ng-container *ngIf="addCardForm.get('BillingState').invalid && (formSubmitted || addCardForm.get('BillingState').touched || addCardForm.get('BillingState').dirty)">
                                    <div *ngIf="addCardForm.get('BillingState').hasError('required')" class="error">
                                        {{'general.required_field' | translate}}
                                    </div>
                                    <div *ngIf="addCardForm.get('BillingState').hasError('pattern')" class="error">
                                        {{'error.address' | translate}}
                                    </div>
                                </ng-container>
                            </div>
                            <div class="col-sm-12 col-md-4">
                                <label class="top-bottom" for="BillingCountry">{{'user.country' | translate}}<span class="error">*</span></label>
                                <input id="BillingCountry" type="text" class="form-control" maxlength="100" formControlName = "BillingCountry"
                                [ngClass]="{ 'is-valid': BillingCountry['valid'], 'is-invalid': BillingCountry['invalid'] }"  />
                                <ng-container *ngIf="addCardForm.get('BillingCountry').invalid && (formSubmitted || addCardForm.get('BillingCountry').touched || addCardForm.get('BillingCountry').dirty)">
                                    <div *ngIf="addCardForm.get('BillingCountry').hasError('required')" class="error">
                                        {{'general.required_field' | translate}}
                                    </div>
                                    <div *ngIf="addCardForm.get('BillingCountry').hasError('pattern')" class="error ta-left">
                                        {{'error.address' | translate}}
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-12 text-right">
                                <button type="button" (click)="cancelAdd()"
                                    class="btn btn-red btn-h-red mr-2">
                                    {{'general.cancel' | translate}}
                                </button>
                                <input [disabled]="clicked" type="submit" class="btn btn-green btn-h-green" title="{{'general.add' | translate}}" 
                                    value="{{'general.add' | translate}}">
                            </div>
                        </div>
                    </form>
                </div>
            </div>  
        </div>
    </div>
    <router-outlet></router-outlet>
</div>
